export const getOrdinalSuffix = (num: number): string => {
    if (num >= 11 && num <= 13) return 'th';
    switch (num % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }; 


  // Utility function to convert timeRange to start_date and end_date
export const getDateRangeFromTimeRange = (timeRange: string): { start_date?: string; end_date?: string } => {
  const now = new Date();
  const end_date = now.toISOString().split('T')[0]; // YYYY-MM-DD format

  // Handle day-based values
  if (timeRange === "0" || timeRange === "All time") {
    return {}; // No date filter for "All time"
  }

  if (timeRange === "ytd") {
    const startOfYear = new Date(now.getFullYear(), 0, 1);
    return {
      start_date: startOfYear.toISOString().split('T')[0],
      end_date
    };
  }

  // Convert string to number for day calculation
  const days = parseInt(timeRange);
  if (!isNaN(days)) {
    const startDate = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
    return {
      start_date: startDate.toISOString().split('T')[0],
      end_date
    };
  }

  return {}; // Default fallback
};

export function getDaysAgo(dateString: string): string {
  const givenDate = new Date(dateString);
  const today = new Date();

  // Normalize to midnight for date-only comparison
  givenDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffTime = today.getTime() - givenDate.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return `${diffDays}d`;
}

export function formatLocalDate(timestamp: string, showTime = false): string {
  const date = new Date(timestamp); // parses ISO string with timezone correctly

  const dateOptions: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  };

  let formatted = date.toLocaleDateString(undefined, dateOptions);

  if (showTime) {
    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    };
    formatted += ' at ' + date.toLocaleTimeString(undefined, timeOptions);
  }

  return formatted;
}








